import { anim, stagger } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import { Badges } from '../../../kit'
import { MaskText, Odometer } from '../../stage/fx'

// Auf Blau: Partikel als weiße, rotierende Kugel
const sphere = (w, h, narrow) => ({
  type: 'sphere',
  x: narrow ? w / 2 : w * 0.78,
  y: narrow ? h * 0.24 : h * 0.5,
  r: narrow ? w * 0.3 : Math.min(h * 0.34, w * 0.17),
  tint: 'white'
})

export const SCIENCE_PARTICLES = [
  [0.04, sphere],
  [0.94, sphere]
]

export default function DmsScience() {
  const s = useCopy('show')
  const c = useCopy('wissenschaft')

  return (
    <div className='sc-full dms-science'>
      <div className='dms-science__col'>
        <h2 className='sc-h2'>
          <MaskText text={s.sphereTitle} at={[0.02, 0.16]} />
        </h2>
        <Line at={[0.14, 0.2]} y={20} className='dms-science__sub'>
          {c.sub}
        </Line>
        <div className='dms-science__stats'>
          {s.scienceStats.map((st, i) => (
            <div
              key={st.label}
              style={anim({ at: stagger(0.22, 0.06, 0.08, i), y: 40 })}
            >
              <Odometer
                value={st.value}
                at={stagger(0.24, 0.06, 0.24, i)}
                className='sc-num dms-science__num'
              />
              <div className='dms-science__label'>{st.label}</div>
            </div>
          ))}
        </div>
        <Badges
          items={c.badges}
          light
          className='dms-science__badges'
          style={anim({ at: [0.6, 0.68], y: 20 })}
        />
      </div>
    </div>
  )
}
